<script async setup lang="ts">
import EventMain from '../../components/event/EventMain.vue';
import EventAbout from '../../components/event/EventAbout.vue';
import EventOthers from '../../components/event/EventOthers.vue';
import BreadcrumbComponent from '@/components/custom/ui/BreadcrumbComponent.vue';

import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

import { useEventStore } from '@/stores/events.store';
import { EventEntity } from '@/entities/interfaces/events';

const eventStore = useEventStore();
const route = useRoute();

const id = computed(() => route.params.id as string);
const timeline = eventStore.getEventsTimeline;
const events = eventStore.getEvents;
const event = eventStore.getEvent;

const setNewEvent = () => {
  const event = eventStore.getEventById(id.value) as EventEntity;
  if (event?.eventUrl) {
    window.location.replace(event?.eventUrl);
  } else {
    eventStore.setEvent(event);
  }
};

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setNewEvent();
});

watch(id, () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setNewEvent();
});

watch(events, () => {
  setNewEvent();
});

const eventStatus = computed(() => {
  if (!event.value || !timeline.value) return;

  const nextEvents = timeline.value?.nextEvents;
  const isNext = nextEvents?.find(
    (item: EventEntity) => item.id == event.value.id
  );

  return isNext
    ? { text: 'Предстоящие мероприятия', link: '/nextEvents' }
    : { text: 'Прошедшие мероприятия', link: '/previousEvents' };
});
</script>

<template>
  <main>
    <BreadcrumbComponent
      :paths="[
        { name: 'Главная страница', link: '/' },
        { name: eventStatus?.text ?? '', link: eventStatus?.link ?? '' }
      ]"
    />
    <EventMain />
    <EventAbout />
    <EventOthers />
  </main>
</template>

<style scoped lang="scss"></style>
